export const usuarioModel = {
  usuario: function () {
    return {
      id: '',
      name: '',
      email: '',
      password: '',
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/Usuario/_model/usuario.js